// components
import { Divider, Tooltip } from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

// hooks
import { useIsVerticalToolbar } from '../ToolbarPosition.context';

// types
import type { ToolbarActionProps } from './ToolbarAction.types';
import { PulsingBadge } from 'components/shared/Badge/PulsingBadge';
import { StyledRelativeBox } from 'components/shared/Box/Box.styles';

const ToolbarAction = ({ action }: ToolbarActionProps) => {
  // Neither of these can come from CSS: the divider's orientation is an aria-orientation, and Popper
  // computes the tooltip placement at runtime.
  const isVertical = useIsVerticalToolbar();
  const dividerOrientation = isVertical ? 'horizontal' : 'vertical';

  return (
    <>
      {action.leftDivider && (
        <Divider orientation={dividerOrientation} variant="middle" flexItem />
      )}
      <Tooltip
        title={action.tooltipLabel}
        placement={isVertical ? 'left' : 'bottom'}
      >
        <StyledRelativeBox>
          <IconButton
            id={action.id}
            aria-label={action.ariaLabel}
            onClick={action.onClick}
            type={action.icon}
            size="small"
            data-tourid={action.actionDataTourId}
            disabled={action.disabled}
          />
          {action?.pulsingBadge?.isActive && (
            <PulsingBadge
              color="primary"
              content={action?.pulsingBadge?.content ?? ''}
            />
          )}
        </StyledRelativeBox>
      </Tooltip>
      {action.rightDivider && (
        <Divider orientation={dividerOrientation} variant="middle" flexItem />
      )}
    </>
  );
};

export default ToolbarAction;
